import type { TooltipItemPositionGetter } from '@mui/x-charts/internals';

const tooltipItemPositionGetter: TooltipItemPositionGetter<'radialLine'> = () => {
  // Todo: to implement
  return null;
};

export default tooltipItemPositionGetter;
